<template>
  <v-container class="px-18 py-8">
    <v-card-title
      class="display-1 font-weight-bold pa-0 mb-8 letter-spacing-normal"
    >
      {{ type === 'credit' ? 'Earnings' : 'Payouts' }}
      <v-progress-linear v-if="userModel.fetching" indeterminate />
    </v-card-title>

    <v-row align="center">
      <v-col cols="5">
        <div class="font-weight-bold">Select Month</div>
      </v-col>
      <v-col cols="7">
        <div id="monthSelect" class="position-relative">
          <v-select
            :menu-props="{ contentClass: 'notranslate' }"
            hide-details
            single-line
            min-height="40px"
            attach="#monthSelect"
            :items="months"
            v-model="filters.month"
            class="body-2 black--text font-weight-bold ma-0 pa-0 ml-2"
            label="Year"
            solo
          />
        </div>
      </v-col>
    </v-row>
    <v-card-text class="pa-0 mt-12">
      <v-row
        v-if="!userModel.fetched && userModel.fetching"
        class="justify-lg-space-between align-center"
      >
        <v-skeleton-loader
          :loading="true"
          height="250"
          type="table-thead, table-tbody, table-tfoot"
        />
      </v-row>
      <v-row v-else class="justify-lg-space-between align-center">
        <v-col class="pa-0">
          <v-data-table
            :loading="userModel.fetching"
            :headers="headers"
            :items="data"
            v-bind="
              earnings.length > 5
                ? { itemsPerPage: 5 }
                : { hideDefaultFooter: true }
            "
            class="border-radius-0 v-data-table-1 v-data-table-1--style3"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td class="d-flex align-start pt-4">
                  {{ $moment(item.date).format('dddd D') }}
                </td>

                <td>
                  <v-col
                    class="px-0"
                    v-for="(earning, count) in item.earnings"
                    :key="`entry-${index}-${count}`"
                  >
                    {{ earning.subject.name }}
                  </v-col>
                </td>

                <td>
                  <v-col
                    class="px-0"
                    v-for="(earning, count) in item.earnings"
                    :key="`amount-${index}-${count}`"
                  >
                    {{ earning.amount }}
                  </v-col>
                </td>
              </tr>
            </template>
            <template v-slot:no-data>
              No {{ type === 'credit' ? 'earnings' : 'payouts' }} made in
              {{ filters.month }}!
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-container>
</template>

<script>
import User from '@models/User';
export default {
  name: 'Earnings',
  props: {
    user: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: 'credit',
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Date',
          value: 'date',
        },
        {
          text: this.type === 'credit' ? 'Name' : 'Project',
          value: 'subject.name',
          sortable: false,
        },
        { text: 'Amount', value: 'amount', sortable: false },
      ],
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      filters: {
        month: $moment().format('MMMM'),
      },
      userModel: new User({
        filters: {
          user_id: this.user.id,
        },
        includes: ['subject'],
      }),
      earnings: [],
    };
  },
  computed: {
    data() {
      let earnings = {};
      this.earnings.forEach((earning) => {
        let date = $moment(earning.created_at).format('YYYY-MM-DD');
        if (!earnings[date]) {
          earnings[date] = [];
        }
        earnings[date].push(earning);
      });
      let data = [];
      for (let date in earnings) {
        data.push({
          date: date,
          earnings: earnings[date],
        });
      }
      return data;
    },
  },
  watch: {
    filters: {
      handler() {
        this.fetchEarnings();
      },
      deep: true,
    },
  },
  methods: {
    async fetchEarnings() {
      let filters = this.clone(this.filters);
      let month = this.months.indexOf(filters.month) + 1;
      delete filters.month;
      filters.from = this.$moment().format('YYYY') + '-' + month + '-1';
      filters.to = $moment(filters.from, 'YYYY-MM-DD')
        .endOf('month')
        .format('YYYY-MM-DD');
      filters.type = this.type;
      this.userModel.setFilters(filters);
      let response = await this.userModel.fetchEarnings();
      if (response) {
        this.earnings = response.data;
      }
    },
  },
  mounted() {
    this.fetchEarnings();
  },
};
</script>

<style scoped></style>
